const BUTTON_SELECTOR = '.button-glow-container :is(button, a.button, a.button-secondary)';

const STAR_PATH =
  'M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.0301 32.273 44.5 25.5C38.1924 18.9276 34 0 34 0C34 0 33.656 17.957 26.5 25.5Z';

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');
const activeIntervals = new WeakMap();

const injectStyles = () => {
  if (document.getElementById('atc-glitter-styles')) return;

  const style = document.createElement('style');
  style.id = 'atc-glitter-styles';
  style.textContent = `
    .atc-glitter-host {
      position: relative;
      overflow: hidden;
    }

    .atc-glitter-shine {
      position: absolute;
      inset: 0;
      pointer-events: none;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.14), transparent);
      transform: translateX(-120%);
      transition: transform 950ms ease;
      z-index: 1;
    }

    .atc-glitter-host:hover .atc-glitter-shine {
      transform: translateX(120%);
    }

    .atc-glitter-particle {
      position: absolute;
      pointer-events: none;
      z-index: 2;
      animation: atc-glitter-float var(--d, 900ms) ease-out forwards;
      transform: translate3d(0, 0, 0);
      opacity: 0;
    }

    @keyframes atc-glitter-float {
      0% {
        opacity: 0;
        transform: translate3d(0, 0, 0) scale(0);
      }

      20% {
        opacity: 1;
        transform: translate3d(0, -6px, 0) scale(1);
      }

      70% {
        opacity: 0.8;
        transform: translate3d(var(--x, 0px), -18px, 0) scale(0.6);
      }

      100% {
        opacity: 0;
        transform: translate3d(var(--x, 0px), -28px, 0) scale(0);
      }
    }
  `;

  document.head.appendChild(style);
};

const isDisabled = (element) => {
  return (
    (element instanceof HTMLButtonElement && element.disabled) ||
    element.getAttribute('aria-disabled') === 'true'
  );
};

const ensureHost = (element) => {
  if (!element.classList.contains('atc-glitter-host')) {
    element.classList.add('atc-glitter-host');
  }

  if (!element.querySelector('.atc-glitter-shine')) {
    const shine = document.createElement('span');
    shine.className = 'atc-glitter-shine';
    element.appendChild(shine);
  }
};

const createParticle = (element) => {
  const particle = document.createElement('span');
  const size = Math.random() * 4 + 2;

  particle.className = 'atc-glitter-particle';
  particle.style.left = `${Math.random() * 95 + 2.5}%`;
  particle.style.top = `${Math.random() * 95 + 2.5}%`;
  particle.style.setProperty('--x', `${(Math.random() - 0.5) * 30}px`);
  particle.style.setProperty('--d', `${700 + Math.random() * 500}ms`);
  particle.innerHTML = `
    <svg width="${size}" height="${size}" viewBox="0 0 68 68" fill="none" aria-hidden="true">
      <path d="${STAR_PATH}" fill="#C60062" />
    </svg>
  `;

  element.appendChild(particle);
  window.setTimeout(() => particle.remove(), 1300);
};

const stopGlitter = (element) => {
  const intervalId = activeIntervals.get(element);
  if (!intervalId) return;

  window.clearInterval(intervalId);
  activeIntervals.delete(element);
};

const startGlitter = (element) => {
  if (prefersReducedMotion.matches || !supportsHover.matches) return;
  if (isDisabled(element) || activeIntervals.has(element)) return;

  ensureHost(element);

  for (let i = 0; i < 12; i += 1) {
    createParticle(element);
  }

  const intervalId = window.setInterval(() => {
    if (!element.isConnected || isDisabled(element)) {
      stopGlitter(element);
      return;
    }

    createParticle(element);
  }, 20);

  activeIntervals.set(element, intervalId);
};

const getTargetFromEvent = (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return null;

  return target.closest(BUTTON_SELECTOR);
};

const onPointerEnter = (event) => {
  const element = getTargetFromEvent(event);
  if (!(element instanceof HTMLElement)) return;

  startGlitter(element);
};

const onPointerLeave = (event) => {
  const element = getTargetFromEvent(event);
  if (!(element instanceof HTMLElement)) return;

  stopGlitter(element);
};

const init = () => {
  injectStyles();

  document.addEventListener('pointerenter', onPointerEnter, true);
  document.addEventListener('pointerleave', onPointerLeave, true);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
